import { Link } from "react-router-dom";
import { FadeIn } from "@/components/Reveal";

const Block = ({ b }) => {
  if (b.h) {
    return <h3 className="mt-8 font-sans text-lg leading-snug text-[#0F172A] sm:text-xl">{b.h}</h3>;
  }
  if (b.bullets) {
    return (
      <ul className="mt-4 space-y-2.5">
        {b.bullets.map((item, k) => (
          <li key={k} className="flex items-start gap-3 text-base leading-relaxed text-[#64748B]">
            <span className="mt-[0.65rem] h-1 w-1 shrink-0 rotate-45 bg-[#1E3A8A]/70" aria-hidden="true" />
            {item}
          </li>
        ))}
      </ul>
    );
  }
  if (b.lines) {
    return (
      <div className="mt-4 space-y-1">
        {b.lines.map((line, k) => (
          <p key={k} className="text-base leading-relaxed text-[#64748B]">{line}</p>
        ))}
      </div>
    );
  }
  return <p className="mt-4 text-base leading-relaxed text-[#64748B]">{b.p}</p>;
};

export default function Legal({ title, doc }) {
  const slug = title.includes("Privacy") ? "privacy" : "terms";
  return (
    <article data-testid={`legal-${slug}`} className="mx-auto max-w-3xl px-4 pb-24 pt-32 sm:px-8 sm:pt-40">
      <FadeIn>
        <p className="eyebrow">Legal</p>
        <h1 className="mt-6 font-sans text-3xl leading-tight tracking-tight text-[#0F172A] sm:text-4xl lg:text-5xl">{title}</h1>
        <div className="mt-6 flex flex-wrap gap-x-8 gap-y-2 border-b border-[#E2E8F0] pb-6 text-sm text-[#94A3B8]" data-testid={`legal-${slug}-meta`}>
          <span>Effective Date: {doc.effective}</span>
          <span>Last Updated: {doc.updated}</span>
        </div>
        <div className="mt-8 space-y-5">
          {doc.intro.map((p, i) => (
            <p key={i} className="text-base leading-relaxed text-[#475569]">{p}</p>
          ))}
        </div>
        {doc.sections.map((s, i) => (
          <section key={i} data-testid={`legal-${slug}-section-${i + 1}`} className="mt-12">
            <h2 className="font-sans text-xl leading-snug text-[#1D4ED8] sm:text-2xl">
              {i + 1}. {s.title}
            </h2>
            {s.blocks.map((b, j) => (
              <Block key={j} b={b} />
            ))}
          </section>
        ))}
        <div className="mt-14 border-t border-[#E2E8F0] pt-8">
          <Link to="/" data-testid="legal-back-home" className="btn-ghost !px-6 !py-3 !text-xs">Back to Home</Link>
        </div>
      </FadeIn>
    </article>
  );
}
